// extracted by mini-css-extract-plugin
module.exports = {"selectItemTitle":"ApproverSelect_selectItemTitle__cSwnP","selectItemEmail":"ApproverSelect_selectItemEmail__2yjIW"};